import {Component, Input, OnInit} from '@angular/core';
import {MaterialWykonczenia} from '../../../../../../../../../../services/slownik/types/material-wykonczenia';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'shared-wartosc',
  templateUrl: './wartosc.component.html'
})

export class WartoscComponent implements OnInit{

  language = window.navigator.language

  readonly SCIANY = 'ściany';
  readonly POMIESZCZENIA = 'pomieszczenia';

  get WARTOSC() { return this.formularzUszkodzenia.controls.wartosc }
  get SZEROKOSC() { return this.formularzUszkodzenia.controls.szerokosc }
  get WYSOKOSC() { return this.formularzUszkodzenia.controls.wysokosc }

  @Input()
  formularzUszkodzenia!: UntypedFormGroup;

  @Input()
  jednostkaPowierzchniUszkodzenia!: string;

  @Input()
  rodzajeMaterialowWykonczenia: MaterialWykonczenia[] = [];

  @Input()
  minimalnaWartoscUszkodzenia!: number;

  @Input()
  maksymalnaWartoscUszkodzenia!: number | null;

  @Input()
  czyWalidacjaWgPowierzchni = false;

  miaraJednostkiUszkodzenia!: string;

  @Input()
  etykietaWartosci = '';

  ngOnInit(): void {
    switch (this.jednostkaPowierzchniUszkodzenia) {
      case 'm':
        this.miaraJednostkiUszkodzenia = this.etykietaWartosci || 'Długość';
        break;
      case 'm2':
        this.miaraJednostkiUszkodzenia = 'Powierzchnia uszkodzenia';
        break;
      case 'szt.':
        this.miaraJednostkiUszkodzenia = 'Liczba sztuk';
        break;
      case 'kpl.':
        this.miaraJednostkiUszkodzenia = 'Liczba kompletów';
        break;
      case 'mb':
        this.miaraJednostkiUszkodzenia = 'Długość';
        break;
    }
  }

  withPeriod(): boolean {
    return this.jednostkaPowierzchniUszkodzenia !== 'szt.' && this.jednostkaPowierzchniUszkodzenia !== 'kpl.';
  }

  pobierzNazweElementu(): string {
    return this.SZEROKOSC && this.WYSOKOSC ? this.SCIANY : this.POMIESZCZENIA;
  }
}
